import * as React from "react";
import {CSSProperties, ReactChild, ReactElement, ReactNode} from "react";
import {Spring, SpringConfig} from "shared/core/animation/react-spring/renderprops";




export class SwitchContainer extends React.Component<SwitchContainerProps, SwitchContainerState> {
    public index:number=0;
    static defaultProps: Partial<SwitchContainerProps> = {
        immediate:false,
        className:''
    };
    public currentChild:HTMLDivElement;
    public nextChild:HTMLDListElement;

    public Spring1:any;
    public Spring2:any;

    public CurrentRef:HTMLDivElement;

    constructor(props: SwitchContainerProps, context?: any) {
        super(props, context);
        this.Ref1Rendered=this.Ref1Rendered.bind(this);
        this.Ref2Rendered=this.Ref2Rendered.bind(this);

        this.state= {
            status:"showed",
            nextChildren:null,
            currentChildren: props.children? props.children : null
        };

    }


    componentWillReceiveProps(nextProps: Readonly<SwitchContainerProps>, nextContext: any): void {
        let nextChildren:any=(nextProps as any).children;
        let currentChildren:any=this.props.children;
        if(nextChildren==null||currentChildren==null) {

            //if there was a change from null to not null or viceversa execute animation
            if (nextChildren != currentChildren)
                if(nextProps.immediate) {
                    this.setState({status: "showed", currentChildren: (nextProps as any).children});
                }
                else {
                    this.SwitchComponent((nextProps as any).children);
                }
        }

        if(nextChildren==false)
            nextChildren=null;
        if(currentChildren==false)
            currentChildren=null;
        if(nextChildren==null||currentChildren==null)
        {
            if(nextChildren!=currentChildren)
                if(nextProps.immediate) {
                    this.setState({status: "showed", currentChildren: (nextProps as any).children});
                }
                else {
                    this.SwitchComponent((nextProps as any).children);
                }
            return;
        }


        nextChildren=React.Children.only(nextChildren);
        currentChildren=React.Children.only(currentChildren);

        if(typeof nextChildren.key!='undefined'&&typeof currentChildren.key!='undefined')
            if(nextChildren.key==currentChildren.key) {
                if(this.state.nextChildren!=null)
                    this.setState({nextChildren:nextChildren});
                else
                    this.setState({currentChildren:nextChildren});


                return;

            }

        if(nextProps.immediate) {
            this.setState({status: "showed", currentChildren: (nextProps as any).children});
        }
        else {
            this.SwitchComponent((nextProps as any).children);
        }


    }

    public  Ref1Rendered(node:any){
        this.Spring1=node;
    }

    public Ref2Rendered(node:any){
        this.Spring2=node;
    }

    public render() {
        let isImmediate=false;
        let toStyles:CSSProperties={};
        let fromStyles:CSSProperties={};

        let isImmediatePrevious=false;
        let fromStylesNext:CSSProperties={};
        let toStylesNext:CSSProperties={};

        let additionalStyles:CSSProperties={};



        switch(this.state.status)
        {
            case "showed":
                isImmediate=true;
                toStyles.height='auto';
                toStyles.opacity=1;
                toStyles.overflow='auto';
                toStyles.position='static';
                additionalStyles.display='none';

                break;
            case "showing":

                fromStyles.height='auto';
                fromStyles.opacity=1;
                toStyles.height=0;
                toStyles.opacity=0;
                toStyles.overflow="hidden";
                toStylesNext.overflow='hidden';
                fromStyles.overflow='hidden';
                fromStylesNext.height=this.CurrentRef!=null?this.CurrentRef.getBoundingClientRect().height:0;
                fromStylesNext.opacity=0;
                if(this.state.nextChildren==null)
                    toStyles.position='static';
                else
                    toStyles.position='absolute';

                additionalStyles.position='static';
                toStylesNext.opacity=1;
                toStylesNext.height='auto';

                break;
            case "switching":
                isImmediate=false;
                toStyles.position='absolute';
                toStyles.top='0';
                toStyles.left=0;
                toStyles.opacity=1;
                toStyles.overflow="hidden";

                fromStyles.overflow='hidden';
                toStylesNext.overflow='hidden';
                fromStylesNext.height=this.CurrentRef!=null?this.CurrentRef.getBoundingClientRect().height:0;

                toStylesNext.height='auto';
                additionalStyles.position='absolute';
                toStylesNext.top=0;

                additionalStyles.left=0;
                additionalStyles.opacity=0;
                break;

        }




        return (
            <div className={'rootSwitchContainer '+this.props.className} style={{overflow:this.state.status=='switching'||this.state.status=='showing'?'hidden':'auto', ...this.props.style}}>
                <div style={{position:this.state.status=="showed"?'static':'relative'}}>
                    <Spring ref={this.Ref1Rendered}  config={{precision:.09}}   from={fromStyles} to={toStyles} immediate={isImmediate} onRest={x=>{if(this.state.status=="showing")this.setState({status:'showed', currentChildren:this.state.nextChildren,nextChildren:null})}} >
                        {
                            (   (styles,ref)=>{
                                return(
                                    <div ref={x=>{this.CurrentRef=x;ref(x)}}  style={{...styles,width:'100%'}}>
                                        {this.state.currentChildren}
                                    </div>
                                )
                            } )as any
                        }

                    </Spring>
                    <Spring ref={this.Ref2Rendered}   config={{precision:.09}}    immediate={isImmediate} from={fromStylesNext} to={toStylesNext}>
                        {
                            (   (styles,ref)=>{
                                let stylesToUse=Object.assign({},styles);
                                if(this.state.nextChildren==null)
                                    styles.height=0;
                                return(
                                    <div ref={x=>ref(x)} style={{...styles,width:'100%',...additionalStyles}} className={'switchcontainer2'}>
                                        {this.state.nextChildren}
                                    </div>
                                )
                            } )as any
                        }
                    </Spring>
                </div>
            </div>
        )
    }

    private SwitchComponent(children: any) {
        if(this.state.status=='switching'||this.state.status=='showing')
        {
            this.Spring2.stop();
            this.Spring1.stop();
        }

        this.setState({
            nextChildren:children?React.cloneElement(children,{ref:x=>this.nextChild=x}):null,
            status:"switching"
        },()=>{
            this.setState({
                status:'showing'
            })

        });
    }
}

/*
 spring({
      from: ballXY.get(),
      velocity: ballXY.getVelocity(),
      to: { x: 0, y: 0 },
      stiffness: 200,
      mass: 1,
       damping: 100
    }).start(ballXY);
 */


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SwitchContainerProps {
    config?:SpringConfig;
    style?:CSSProperties;
    className?:string;
    children:any;
    immediate:boolean;
}

interface SwitchContainerState {
    status:'showing'|'showed'|'switching'
    currentChildren:ReactNode;
    nextChildren:ReactNode;

}

//#endregion "My Region"